import serviceBilling from '../template/serviceBilling/router/index';
import quickCashier from '../template/quickCashier/router/index';

import setScheduling from '../template/reservationList/template/setScheduling/router/index';
import reservationList from '../template/reservationList/router/index';
import packageBuy from '../template/packageBuy/router/index';
import memberAdmin from '../template/memberAdmin/router/index';
import cashBox from '../template/cashBox/router/index';
import beautyCard from '../template/beautyCard/router/index';
import attendance from '../template/attendance/router/index';
import orderSettlement from '../template/orderSettlement/router/index';
import settlementSuccess from '../template/settlementSuccess/router/index';
import roundCard from '../template/roundCard/router/index';

import orderDeatilsData from '../template/orderDeatilsData/router/index';

export default [{
  path: '/stage/index',
  name: 'stage-index',
  title: '前台',
  component: () => import('@/views/stage/index')
}, ...serviceBilling, ...quickCashier, ...setScheduling,
...reservationList, ...packageBuy, ...memberAdmin, ...cashBox, ...beautyCard, ...attendance, ...orderSettlement, ...settlementSuccess, ...roundCard, ...orderDeatilsData
];
